/* Publish by EComposer at 2026-09-30 18:57:33*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-req2n1foou"]=  window.__ectimmers["ecom-req2n1foou"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-req2n1foou').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-req2n1foou', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rq0qg2ob7pf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rq0qg2ob7pf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mefs02424s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mefs02424s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5dyf71pov6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dyf71pov6b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0du1r8pcunu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0du1r8pcunu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdaltjm57m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdaltjm57m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5jz4tl3q8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5jz4tl3q8t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f23t8yu03b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f23t8yu03b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5uacu73o855').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5uacu73o855', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7lnsr0xrv1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7lnsr0xrv1h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ku8plasfof8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ku8plasfof8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nd5yb320kl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nd5yb320kl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rdi7c6p8i5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rdi7c6p8i5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5jp6pot3td').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5jp6pot3td', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-blaglo91gio').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-blaglo91gio', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jr1pt9aksis').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jr1pt9aksis', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nphg4r7kup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nphg4r7kup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nfglofwrtt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nfglofwrtt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7dwwe3osyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7dwwe3osyn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ubs4t7n1rsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubs4t7n1rsk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z4cspxqydag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z4cspxqydag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jiadau3lnkl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jiadau3lnkl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cv4sp1mfyps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cv4sp1mfyps', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3sp9xsv7roc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3sp9xsv7roc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pwuy3i0b8ib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pwuy3i0b8ib', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3zhzv1fkmcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3zhzv1fkmcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nulb8pu95e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nulb8pu95e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6yz4nfbe0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6yz4nfbe0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ti2ua5esdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ti2ua5esdg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbs610bg69e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbs610bg69e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8phyr9ye1s4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8phyr9ye1s4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xe8ulyvg2s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xe8ulyvg2s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2h5noomlx2g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2h5noomlx2g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-miw5yrq0qlp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-miw5yrq0qlp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3qidm92ofwj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3qidm92ofwj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ad8sq9tpad').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ad8sq9tpad', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ckr8ki1lti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ckr8ki1lti', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kiu3kwxx3wc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kiu3kwxx3wc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qaa6e13reot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qaa6e13reot', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvbwtj9grc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvbwtj9grc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qz5kxzyt33e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qz5kxzyt33e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0scovz21kqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0scovz21kqd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o61zwqcyz0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o61zwqcyz0q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sthhybzfjz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sthhybzfjz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3dugqwgvhzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3dugqwgvhzb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iily4dsfmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iily4dsfmf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pv3c1tgelsq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pv3c1tgelsq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnbu3udzjch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnbu3udzjch', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4sl1vaxcduu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4sl1vaxcduu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iqsgxk5q5yd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iqsgxk5q5yd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlxzw57e7x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlxzw57e7x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jc1h1d8drnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jc1h1d8drnl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9iwp3hkmvoh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9iwp3hkmvoh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3llfp4wzy9x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3llfp4wzy9x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0bxgx33emh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0bxgx33emh6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-epdvlvyt17m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-epdvlvyt17m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1qzg67046cm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1qzg67046cm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnimwgf0hus').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnimwgf0hus', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s13rzkrob9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s13rzkrob9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-02icptv65xld').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-02icptv65xld', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avjpiss4frp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avjpiss4frp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qzam2u2cnwh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qzam2u2cnwh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwoawwyt8kd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwoawwyt8kd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8506b85oi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8506b85oi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gvgq8blcijj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gvgq8blcijj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-isiy3yell2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-isiy3yell2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lf1sf9jeqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lf1sf9jeqb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nez4n91eqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nez4n91eqw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pvqocn58ts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvqocn58ts', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x3rw0385rq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3rw0385rq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-larc394oyor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-larc394oyor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-quwm7a434h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-quwm7a434h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uxi0t8jirj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxi0t8jirj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8d2j3nk87ct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8d2j3nk87ct', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o1tefnatic').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o1tefnatic', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijr1u6pl7u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijr1u6pl7u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yqge2jxqq6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yqge2jxqq6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71hbj4lwoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71hbj4lwoi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-unjqspsctn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-unjqspsctn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7td354j8qih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7td354j8qih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zg9aj7jkp3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zg9aj7jkp3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mojymmpglq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mojymmpglq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93ouagm7wit').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93ouagm7wit', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6pym421n3e4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6pym421n3e4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-135b1uvpl04').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-135b1uvpl04', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-839i6j9xf8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-839i6j9xf8f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1d8uh7gqdvy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1d8uh7gqdvy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-733nr45hq67').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-733nr45hq67', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4bon3kol2fw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4bon3kol2fw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0xjop8n28mzk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xjop8n28mzk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vdxxyabs1sf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vdxxyabs1sf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yutgurriir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yutgurriir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-flbjkiqxjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-flbjkiqxjv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4bxv4fu9n9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4bxv4fu9n9b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6j0170rnbm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6j0170rnbm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c7idd3gr62n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c7idd3gr62n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-us4tildqch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-us4tildqch', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rar7f441kw9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rar7f441kw9', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-78rggkbod8n"]=  window.__ectimmers["ecom-78rggkbod8n"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-78rggkbod8n"]["6yx77jbhc"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-78rggkbod8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-78rggkbod8n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u2s4gmknw4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u2s4gmknw4b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94nf99wvf68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94nf99wvf68', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gheqwzflljn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gheqwzflljn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-62go2c9s0xv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-62go2c9s0xv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eavdmalnia7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eavdmalnia7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8x9tkqrb5rc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8x9tkqrb5rc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jzrkge9b16').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jzrkge9b16', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ceqaxn3lsmi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ceqaxn3lsmi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-apcmu9dobow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-apcmu9dobow', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r1yzskzj8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r1yzskzj8s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yfpt4g760n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yfpt4g760n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1cvq8ai0qvsh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1cvq8ai0qvsh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdyfqlskyzf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdyfqlskyzf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nvzjnv5mgv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nvzjnv5mgv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wkxcfjjmhj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wkxcfjjmhj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wc9scc2mwns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wc9scc2mwns', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-epbrcwmrlrr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-epbrcwmrlrr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cr78dk3swwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cr78dk3swwr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn32s3z96kh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn32s3z96kh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5r60e2nil').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5r60e2nil', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmlxo7dgyr4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmlxo7dgyr4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yu4p4nb7fur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yu4p4nb7fur', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-318lc02jvd2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-318lc02jvd2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0k1z91t8orog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0k1z91t8orog', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sn9zf6qwohh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sn9zf6qwohh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lf7s02icgbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lf7s02icgbs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ybq6mjil0z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ybq6mjil0z', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5p7mycuvemf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5p7mycuvemf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5a275wd72qc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5a275wd72qc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lzf3w17k61g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lzf3w17k61g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5ohiby40ns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5ohiby40ns', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85jaxqqt7ri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85jaxqqt7ri', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zu8of69m0vm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zu8of69m0vm', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7p0xsyxr37"]=  window.__ectimmers["ecom-7p0xsyxr37"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=($=this.settings.disable_auto_close__tablet)!=null?$:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function G(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-7p0xsyxr37').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7p0xsyxr37', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-89i2mfdl94e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-89i2mfdl94e', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-end8qpwvtdn"]=  window.__ectimmers["ecom-end8qpwvtdn"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-end8qpwvtdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-end8qpwvtdn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eby697f7xw4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eby697f7xw4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4y2o2uwkat').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4y2o2uwkat', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zpyz9wn21j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zpyz9wn21j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8l3sn1jf7rv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8l3sn1jf7rv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51b3j1j7eig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51b3j1j7eig', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rcudx17ml9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rcudx17ml9k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gbj5j2b20kh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gbj5j2b20kh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-svbv0dp8pl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-svbv0dp8pl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrtwxjuckxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrtwxjuckxa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mpgjklriwe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mpgjklriwe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7t0lnpv4z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7t0lnpv4z', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a2va3fsxo29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a2va3fsxo29', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bw2tkr8xvkj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bw2tkr8xvkj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9nclnz5c5gh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9nclnz5c5gh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4irbqjxfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4irbqjxfd', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-deq43jkiqhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-deq43jkiqhi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rk8w7s0w8f9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rk8w7s0w8f9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9czqftzflqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9czqftzflqb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lzbrt44ah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lzbrt44ah', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s4649wjoy1l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4649wjoy1l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}